import { render, staticRenderFns } from "./DocPreview.vue?vue&type=template&id=9c42d47a&"
import script from "./DocPreview.vue?vue&type=script&lang=js&"
export * from "./DocPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports